import { LoaderSquares } from '@/components/ui/LoaderSquares'
import { Suspense, useRef } from 'react'
import { QueryErrorBoundary } from '../QueryErrorBoundary'
import { ContentPanel } from './ContentPanel'
import { CatalogPageHeader } from './ContentPanel/CatalogPageHeader'
import { HeaderActions } from './ContentPanel/HeaderActions'
import { HeaderFilters } from './ContentPanel/HeaderFilters'
import { TileGrid } from './ContentPanel/TileGrid'
import { PageLayoutProvider } from './useAppPageLayout'

function AppPage2() {
  const headerActionsRef = useRef<HTMLDivElement>(null)

  return (
    // Page Container
    <QueryErrorBoundary errorMessage={<span>Failed to fetch page layout</span>}>
      <Suspense fallback={<AppPageLoading />}>
        <ContentPanel>
          <PageLayoutProvider>
            <CatalogPageHeader>
              <HeaderFilters actionsRef={headerActionsRef} />
              <HeaderActions ref={headerActionsRef} />
            </CatalogPageHeader>
            <TileGrid />
          </PageLayoutProvider>
        </ContentPanel>
      </Suspense>
    </QueryErrorBoundary>
  )
}

export function AppPageLoading() {
  return (
    <div className="flex h-full w-full items-center justify-center">
      {/* <LoadingComponent
        style={{ height: MAIN_CONTENT_HEIGHT, width: '100%' }}
        icon={<IconWaitOutline fontSize={96} />}
      /> */}
      {/* <LoaderDots /> */}
      <LoaderSquares />
    </div>
  )
}

export default AppPage2
